<script setup lang="ts">
/* eslint-disable max-len */
export interface IconDownload {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconDownload>(), { fill: "#A9B7D1", width: 16, height: 16 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9393 25.0607C14.5251 25.6464 15.4749 25.6464 16.0607 25.0607L25.6066 15.5147C26.1924 14.9289 26.1924 13.9792 25.6066 13.3934C25.0208 12.8076 24.0711 12.8076 23.4853 13.3934L15 21.8787L6.51472 13.3934C5.92893 12.8076 4.97918 12.8076 4.3934 13.3934C3.80761 13.9792 3.80761 14.9289 4.3934 15.5147L13.9393 25.0607ZM13.5 0L13.5 24H16.5V0L13.5 0Z" fill="#A9B7D1" />
    <line y1="30.5" x2="30" y2="30.5" :stroke="props.fill" stroke-width="3" />
    <line x1="1.5" y1="22" x2="1.5" y2="29" :stroke="props.fill" stroke-width="3" />
    <line x1="28.5" y1="22" x2="28.5" y2="29" :stroke="props.fill" stroke-width="3" />
  </svg>
</template>
